module.exports = __webpack_public_path__ + "img/login_background.1f4c805f.jpg";